var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCallMergeAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "person_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1263_5642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1263_5642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add_2",
    d: "M11.9998 9.33366V7.33366H9.99984V6.00033H11.9998V4.00033H13.3332V6.00033H15.3332V7.33366H13.3332V9.33366H11.9998ZM5.99984 8.00033C5.2665 8.00033 4.63873 7.73921 4.1165 7.21699C3.59428 6.69477 3.33317 6.06699 3.33317 5.33366C3.33317 4.60033 3.59428 3.97255 4.1165 3.45033C4.63873 2.9281 5.2665 2.66699 5.99984 2.66699C6.73317 2.66699 7.36095 2.9281 7.88317 3.45033C8.40539 3.97255 8.6665 4.60033 8.6665 5.33366C8.6665 6.06699 8.40539 6.69477 7.88317 7.21699C7.36095 7.73921 6.73317 8.00033 5.99984 8.00033ZM0.666504 13.3337V11.467C0.666504 11.0892 0.763726 10.742 0.958171 10.4253C1.15262 10.1087 1.41095 9.86699 1.73317 9.70033C2.42206 9.35588 3.12206 9.09755 3.83317 8.92533C4.54428 8.7531 5.2665 8.66699 5.99984 8.66699C6.73317 8.66699 7.45539 8.7531 8.1665 8.92533C8.87761 9.09755 9.57762 9.35588 10.2665 9.70033C10.5887 9.86699 10.8471 10.1087 11.0415 10.4253C11.2359 10.742 11.3332 11.0892 11.3332 11.467V13.3337H0.666504Z",
    fill: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCallMergeAdd);
export default __webpack_public_path__ + "static/media/grey-call-merge-add.78f85274eaba55d793c5b8679ec533a8.svg";
export { ForwardRef as ReactComponent };